<template>
  <div class="yx-personal-info-page main-layout">
    <el-card class="box-form box-inner">
      <c-title slot="header" :title="'新增'"></c-title>
      <el-card shadow="never" class="div-scroll">
        <el-row class="add-form" v-loading="handleLoading">
          <el-form
            size="small"
            :model="handleData"
            ref="cForm"
            :rules="formRules"
            :label-width="'150px'"
          >
            <el-col :span="24" class="sub-title">基本信息</el-col>
            <el-col :span="16">
              <c-form-item :formItems="formItemsBasic1" ref="cFormItem1" />
            </el-col>
            <el-col :span="8">
              <div class="upload-box">
                <h4>照片：</h4>
                <el-form-item prop="photoUrl" label-width="0">
                  <el-upload
                    action="/account/sys/static/upload"
                    list-type="picture-card"
                    accept="image/jpeg,image/jpg,image/png,image/bmp,image/gif"
                    :file-list="fileList"
                    :before-upload="beforeUpload"
                    :on-success="handlePictureSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handlePictureRemove"
                    :on-error="handleError"
                    :http-request="customUpload"
                    :show-file-list="false"
                  >
                    <img
                      style="width: 100%; height: 100%"
                      :src="handleData.photoUrl"
                      alt=""
                      v-if="handleData.photoUrl"
                    />
                    <i class="el-icon-plus" slot="default" v-else></i>
                  </el-upload>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="16">
              <c-form-item :formItems="formItemsBasic2" ref="cFormItem2" />
            </el-col>
            <el-col :span="8">
              <div class="tips-container">
                <div class="tips">
                  <div class="title">
                    <i class="el-icon-info"></i><span>温馨提示</span>
                  </div>
                  <p>1、核对个人信息并完善以下内容；</p>
                  <p>2、上传照片必须为2寸蓝底登记照；</p>
                  <p>3、以下信息将作为学生学籍信息；</p>
                  <p>
                    注：填写的内容将纳入个人档案，请谨慎填写确保信息真实有效。
                  </p>
                </div>
              </div></el-col
            >
            <el-col :span="24" class="sub-title">学籍信息</el-col>
            <el-col :span="24">
              <c-form-item :formItems="formItems" ref="cFormItem3" />
            </el-col>

            <el-col :span="24" style="text-align: center">
              <el-form-item label-width="0">
                <slot name="other">
                  <el-button
                    type="primary"
                    @click="submit"
                    size="medium"
                    :disabled="isSubmit"
                    >提交</el-button
                  >
                </slot>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import { guid } from "@/libs/tools.js";
import Configs from "./data/add.js";
import MHandle from "@/mixins/MHandle.js";
import { mapState } from "vuex";
import { getOrgOptions } from "@/libs/searchSelect";
import mUpload from "@/mixins/MUpload.js";
let mHandle = MHandle({
  handleGetPath: "/account/base/student",
  handleInsertPath: "/account/base/student/save",
  handleUpdatePath: "/account/base/student/update",
  handleDownLoadPath: "",
  handleData: {
    img: "",
    usedName: "",
    examScore: "",
    academicDegree: "",
    academicYear: "",
    addressAreaCode: "",
    addressInfo: "",
    classId: "",
    className: "",
    collegeId: "",
    collegeName: "",
    dateBirth: "",
    departmentId: "",
    departmentName: "",
    email: "",
    enrollmentYear: "",
    examNumber: "",
    graduateYear: "",
    idCard: "",
    idCardType: "身份证",
    isDisability: 0,
    isLoan: 0,
    isStay: 1,
    isOrphan: 0,
    loanAmount: 0,
    majorId: "",
    majorName: "",
    marriageStatus: 0,
    nationCode: "",
    phoneNumber: "",
    politicalCode: "",
    qqCode: "",
    sex: "",
    studentId: "",
    studentName: "",
    studentSourceAreaCode: "",
    studentStatus: "",
    wxCode: "",
    joinPartyTime: "",
    familyBackgroundCode: "",
    healthConditionCode: "",
    familyPhone: "",
    postcode: "",
    photoUrl: "",
    nativePlace: "",
  },
});
export default {
  mixins: [mHandle, mUpload],
  provide() {
    return {
      cForm: this,
    };
  },
  data() {
    let {
      formItemsBasic1,
      formItemsBasic2,
      formItemsBasic3,
      formItemsBasic4,
      formRules,
    } = Configs(this);
    return {
      formItemsBasic1,
      formItemsBasic2,
      formItems: formItemsBasic3,
      formItemsBasic4,
      formRules,
      value: {},
      action: "http://61.184.241.22:8088/zlf/upload?prefix=appointment",
      departmentOptions: [],
      majorOptions: [],
      classOptions: [],
      fileList: [],
      isSubmit: false,
    };
  },
  watch: {
    handleData: {
      handler(val) {
        this.value = val;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  created() {
    // this.getCollegeOptions();
    // getOrgOptions(this, { type: "college" }, "", null, 1);
    this.getSysAreaList();
  },
  mounted() {},
  beforeDestroy() {
    this.$refs.cForm.resetFields();
  },
  methods: {
    getSysAreaList() {
      this.$http
        .get("/account/sys-area/getSysAreaList")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.formItemsBasic2[1].options = res.data[0].sysAreaLists;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 获取学院
    getCollegeOptions() {
      this.$http
        .get("/account/sys/org/listByType?type=college")
        .then((res) => {
          // console.log(res)
          // let options = [];
          if (res.code == this.SUCCESS_CODE) {
            this.formItemsBasic3[1].options = res.data.map((item) => {
              return {
                label: item.name,
                value: item.id,
              };
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    submit(fn) {
      this.$refs.cForm.validate((valid) => {
        if (valid) {
          //   验证通过后将数据提交保存
          if (this.handleData.id) {
            this.handleUpdate();
          } else {
            this.handleInsert();
          }
        } else {
          return false;
        }
      });
    },
    beforeUpload(file) {
      console.log(file);
      const isLt200 = file.size / 1024 > 200;
      if (isLt200) {
        return this.$message.warning("照片大小不超过200KB,请重新上传！");
      } else {
        return true;
      }
    },
    handlePictureSuccess(res, file, fileList) {
      if (res.code == this.SUCCESS_CODE) {
        file.url = res.data.url;
        this.fileList = fileList;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureRemove(file, fileList) {
      this.fileList = fileList;
      let index = this.pictureUrl.findIndex((item) => item.name == file.name);
      this.pictureUrl.splice(index, 1);
    },
    handleError(err) {
      this.$message.error("上传失败，" + err);
    },
    customUpload(e) {
      let file = e.file;
      if (file.size / 1024 > 200) return;
      // let fileName = guid();
      let fileName = this.handleData.studentNo || guid();
      this.obsUpload(file, fileName, this.afterObsUpload);
    },
    afterObsUpload(obsUrl,file) {
      this.handleData.photoUrl = obsUrl;
    },
    // obsUpload(file, key, callback) {
    //   // console.log(file);
    //   let self = this;
    //   this.isLoading = true;
    //   var ak = self.$OBS_AK;
    //   var sk = self.$OBS_SK;
    //   var server = self.$OBS_SERVER;
    //   var bucket = self.$OBS_BUCKET;
    //   let prefix = self.$OBS_PREFIX;
    //   var obsClient = new ObsClient({
    //     access_key_id: ak,
    //     secret_access_key: sk,
    //     server: server,
    //     timeout: 60 * 5,
    //   });
    //   // put objects
    //   obsClient
    //     .putObject({
    //       Bucket: bucket,
    //       Key: key,
    //       Metadata: { property: "property-value" },
    //       SourceFile: file,
    //     })
    //     .then(function (result) {
    //       if (result.CommonMsg.Status == 200) {
    //         console.log(result);
    //         // 上传成功后的操作
    //         callback && callback(file, key);
    //         let obsUrl = prefix + key;
    //         self.handleData.photoUrl = obsUrl;
    //         console.log(self.handleData.photoUrl);
    //       }
    //       self.isLoading = false;
    //     })
    //     .catch(function (err) {
    //       self.isLoading = false;
    //       self.$message.error(err);
    //     });
    // },
  },
};
</script>

<style lang="less" scoped>
.tips-container {
  padding-left: 150px;
  .tips {
    margin-bottom: 15px;
    color: #787878;

    i.el-icon-info {
      vertical-align: middle;
      font-size: 18px;
      margin-right: 5px;
      color: #409eff;
    }

    .title {
      font-size: 16px;
      line-height: 30px;
      // padding-left: 25px;
      color: #5a5a5a;
    }

    p {
      text-indent: 2em;
      line-height: 26px;
    }
  }
}
</style>

